import { createBrowserRouter } from 'react-router-dom';

import { baseRouter } from './common/baseRouter';
import ErrorPage from './common/app/error/page';

export const router = createBrowserRouter([
  {
    path: '',
    // Catch render/loader errors *inside* the router. Unlike the top-level
    // <ErrorBoundary> in main.tsx (which sits above RouterProvider and so stays
    // stuck on the error screen until a full reload — the Back button can't
    // recover because the router itself is unmounted), a route errorElement is
    // rendered within router context and is automatically cleared by the next
    // navigation. So Back / Go Home recover without a hard refresh.
    errorElement: <ErrorPage />,
    children: baseRouter,
  },
]);
